import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { contentPage } from 'src/services/ContentApi'
import { PostNewsletter } from 'src/services/user'
import { newsLetterSchema } from 'src/lib/Validation'
import { newsLetterValues } from 'src/lib/InitialValues'
import TextFieldWrapper from 'src/components/TextFieldWrapper'
import Loader from 'src/components/Loader'

const Newsletter = ({ onClose }) => {
  const [myData, setMyData] = useState({})
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [loader, setLoader] = useState(false)
  const language = useSelector((state) => state.language)
  useEffect(() => {
    const getData = async () => {
      setLoader(true)
      try {
        const data = await contentPage('page_newsletter', language)
        setMyData(data)
      } catch (error) {
        throw error
      }
      setLoader(false)
    }
    getData()
  }, [language])

  const onSubmit = async (values) => {
    const { data } = await PostNewsletter(values)
    if ((data.status = 'SUCCESS')) {
      setIsSubmitted(true)
    }
  }

  return (
    <section className="helpline-container">
      <h2>{myData.txt_newsletterheading}</h2>
      {loader ? (
        <Loader />
      ) : (
        <div className="container-fluid" id="newsletter_form">
          {isSubmitted ? (
            <div className="container-fluid" id="newsletter_confirm">
              <div className="row">
                <div className="col-md-12 text-center">
                  <p>&nbsp;</p>
                  {myData.txt_newslettersuccess}
                  <p>&nbsp;</p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 text-center">
                  <div className="form-group">
                    <button
                      className="btn btn-default btn-primary"
                      id="newsletterClose"
                      name="close"
                      onClick={() => {
                        setIsSubmitted(false)
                        onClose()
                      }}
                    >
                      {myData.txt_closebutton}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <Formik
                  initialValues={newsLetterValues}
                  validationSchema={newsLetterSchema}
                  onSubmit={onSubmit}
                >
                  {(formik) => (
                    <Form className="register-form-wrap">
                      <div className="col-md-10 offset-md-1" id="newsletter">
                        <TextFieldWrapper
                          label={myData.txt_newsletterfirstname}
                          formik={formik}
                          name="firstName"
                        />
                        <TextFieldWrapper
                          label={myData.txt_newsletterlastname}
                          formik={formik}
                          name="lastName"
                        />
                        <TextFieldWrapper
                          label={myData.txt_newsletteremailaddr}
                          formik={formik}
                          name="email"
                          type="email"
                        />
                        <div className="form-group">
                          <button
                            className="btn btn-default btn-primary w-50"
                            type="submit"
                            disabled={formik.isSubmitting}
                          >
                            {myData.txt_submitbutton}
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  )
}
Newsletter.propTypes = {
  onClose: PropTypes.func.isRequired,
}
export default Newsletter
